import { useCallback, useState } from 'react';

export const useFakeLoader = (freez: number) => {
  const [fakeLoading, setFakeLoading] = useState(false);
  const startFakeLoading = useCallback(() => {
    setFakeLoading(true);
    const timeoutId = setTimeout(() => {
      setFakeLoading(false);
    }, freez);
    return () => clearTimeout(timeoutId);
  }, [freez]);

  return { fakeLoading, startFakeLoading };
};
